import { AI_PROCESS_SCOPE_TYPE } from 'app/pages/system/aiProcesses/shared/aiProcess.constants';
import _ from 'lodash';

export const getOptionName = option => option.name;

export const isSameOption = (option, value) => option.value === value?.value;

// A saved process the list does not hold (not loaded yet, or no longer loan-scoped) stays selectable
// under its id, so editing another field of the action never silently drops it.
export const getLoanAiProcessOptions = ({ aiProcesses, processId }) => {
  const options = aiProcesses
    .filter(({ scopeType }) => scopeType === AI_PROCESS_SCOPE_TYPE.LOAN_APPLICATION)
    .map(({ id, name }) => ({ name, value: id }));
  const isUnlistedProcess =
    !_.isNil(processId) && !options.some(({ value }) => value === processId);

  return isUnlistedProcess ? [...options, { name: processId, value: processId }] : options;
};

export const getSelectedOption = ({ options, value }) =>
  options.find(option => option.value === value) ?? null;
